import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { HttpHelpers } from 'src/app/shared/helpers/http.helpers';
import { environment } from 'src/environments/environment';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class TenantGuard implements CanActivate {
  constructor(
    private router: Router,
    public auth: AuthService,
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | import("@angular/router").UrlTree | import("rxjs").Observable<boolean | import("@angular/router").UrlTree> | Promise<boolean | import("@angular/router").UrlTree> {
    // now here, we'll check for 2 things. 1 if the setting to force login is enable, 2 if the person is authenticated or not

    // replace the "true" by the setting value we'll provide for it (aka setting to enforce login)
    if(!this.auth.isAuthenticated && false) {
      if (!environment.deviceApp && !HttpHelpers.getSubdomain()) {
        return this.router.parseUrl('');
      } else {
        if(state.url != "/login-home") {
          return this.router.parseUrl('/login-home');
        } 
      }
    } else {

      //console.log(HttpHelpers.getSubdomain());
      if (!environment.deviceApp && !HttpHelpers.getSubdomain()) {
        //console.log(state.url);

        //console.log("redirect to landing page"); // this is where my code redirects after it doesn't find the device
        //return this.router.parseUrl('');
        return this.router.parseUrl('/error-page');
        
      }
    }
    

    return true;
  }
}